import qs from "query-string";
import { storageAdapter } from "./storageAdapter";

export function forceReinitiliazationIfRequested(search) {
  const params = qs.parse(search);
  if (params.fromOnline) {
    storageAdapter("offlineModeWasInitialized").remove();
  }
}
